import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next'

import Button from '@components/common/Button/Button'

import MotionText from '@/components/common/Motion/MotionText'
import MotionImage from '@/components/common/Motion/MotionImage'

import WarningVisual from '@assets/visuals/warning.webp'
import HeaderBack from '@/components/dashboard/Header/HeaderBack'

import { useTourStore } from '@/store/useTourStore'
import { usePageSetup } from '@/hooks/usePageSetup'

export const ExpensesDisclaimerPage = () => {
  const { t } = useTranslation();
  usePageSetup(t('expenses.pageTitle.disclaimer'))

  const navigate = useNavigate()

  const setExpensesDisclaimerAcknowledged = useTourStore(
    (state) => state.setExpensesDisclaimerAcknowledged
  )

  return (
    <div className="h-full bg-white flex flex-col">
      <HeaderBack />
      <div className="flex-1 flex flex-col px-5">
        <MotionImage
          className="h-[9rem] w-[9rem] mx-auto object-cover mb-8 p-1"
          src={WarningVisual}
          alt={"Warning"}
        />
        <div className="space-y-4">
          <MotionText
            as="h2"
            className="text-[2.5rem] font-hubot font-black uppercase leading-none text-center mx-8 mb-8"
            delay={0.2}
          >
            {t('expenses.disclaimer.title')}
          </MotionText>
          <MotionText
            as="p"
            className="text-zinc-700 text-sm text-left"
            delay={0.4}
          >
            <Trans i18nKey="expenses.disclaimer.text1" components={{ strong: <strong /> }} />
          </MotionText>
          <MotionText
            as="p"
            className="text-zinc-700 text-sm text-left"
            delay={0.5}
          >
            {t('expenses.disclaimer.text2')}
          </MotionText>
        </div>
      </div>

      <motion.div 
        className="px-5 pb-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{
          duration: 0.2,
          ease: "easeOut"
        }}
      >
        <div className="flex flex-col gap-2">
          <Button
            variant="secondary"
            className="h-12"
            onClick={() => {
              setExpensesDisclaimerAcknowledged(true)
              navigate('/expenses/create')
            }}
          >
            <span>{t('expenses.disclaimer.dontShowAgain')}</span>
          </Button>
          <Button
            variant="primary"
            className="h-12 w-full"
            onClick={() => navigate('/expenses/create')}
          >
            <span>{t('expenses.disclaimer.understood')}</span>
          </Button>
        </div>
      </motion.div>
    </div>
  )
}

export default ExpensesDisclaimerPage
